import React, { useEffect, useState } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const BinanceBalance = () => {
  const BaseUrl = process.env.REACT_APP_API;

  const [data, setData] = useState({
    mainAccount: null,
    subAccount1: null,
    subAccount2: null,
    totalAUM: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [main, sub1, sub2, sub3] = await Promise.all([
          axios.get(`${BaseUrl}/api/binance/balance/main`),
          axios.get(`${BaseUrl}/api/binance/balance/sub1`),
          axios.get(`${BaseUrl}/api/binance/balance/sub2`),
        ]);

        const totalAUM =
          parseFloat(main.data.totalBalanceUSDT) +
          parseFloat(sub1.data.totalBalanceUSDT) +
          parseFloat(sub2.data.totalBalanceUSDT) 

        setData({
          mainAccount: main.data,
          subAccount1: sub1.data,
          subAccount2: sub2.data,
          totalAUM,
        });
      } catch (error) {
        console.error("Error fetching Binance data:", error);
      }
    };

    fetchData();
  }, []);

  // Function to calculate percentage
  const calculatePercentage = (balance, total) => {
    return ((balance / total) * 100).toFixed(2) + "%";
  };

  // Function to render table
  const renderTable = (account, name) => {
    if (!account) return null;

    return (
      <div className="card basic-data-table">
        <div className="card-header">
          <h5 className="card-title mb-0">{name}</h5>
        </div>
        <div className="card-body overflow-auto p-2" style={{ maxHeight: "300px" }}>
          <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
            <thead>
              <tr>
                <th>Wallet Name</th>
                <th>Balance in BTC</th>
                <th>Balance in USD</th>
                <th>Percentage</th>
              </tr>
            </thead>
            <tbody>
              {account.balances?.map((wallet, index) => (
                <tr key={index}>
                  <td>{wallet.walletName}</td>
                  <td>{wallet.originalBalance}</td>
                  <td>${wallet.balanceInUSD}</td>
                  <td>{calculatePercentage(wallet.balanceInUSD, account.totalBalanceUSDT)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="card-header text-white">
          <h6 className="mb-0">Total: ${account.totalBalanceUSDT}</h6>
        </div>
      </div>
    );
  };

  // Pie Chart Data
  const chartData = {
    labels: [
      `Main Account (${calculatePercentage(data.mainAccount?.totalBalanceUSDT || 0, data.totalAUM)})`,
      `Keshav Account (${calculatePercentage(data.subAccount1?.totalBalanceUSDT || 0, data.totalAUM)})`,
      `QI Cap Account (${calculatePercentage(data.subAccount2?.totalBalanceUSDT || 0, data.totalAUM)})`,
    ],
    datasets: [
      {
        data: [
          data.mainAccount?.totalBalanceUSDT || 0,
          data.subAccount1?.totalBalanceUSDT || 0,
          data.subAccount2?.totalBalanceUSDT || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
      },
    ],
  };

  return (
    <div id="msform" className="container mt-4">
      {/* Binance Account Dashboard Section */}
      <h3 className="mb-3 text-center">Binance Account Summary</h3>
      <div className="container mt-4">
        <div className="row">
          {/* Total AUM (Col-6) */}
          <div className="col-md-6">
            <div className="card basic-data-table">
              <div className="card-header text-white text-center">
                <h4 className="mb-0">Total Crypto AUM</h4>
              </div>
              <div className="card-body text-center">
                <h6>${data.totalAUM.toFixed(2)}</h6>
              </div>
            </div>
          </div>

          {/* Pie Chart (Col-6) */}
          <div className="col-md-6">
            <div className="card">
              <div className="card-header text-center">
                <h5>Overview of AUM</h5>
              </div>
              <div className="card-body d-flex justify-content-center">
                <div style={{ width: "100%", maxWidth: "300px" }}>
                  <Pie data={chartData} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Render Tables */}
      <div className="mb-12">
          <h2 className="text-2xl font-bold ">Master Account</h2>
          {renderTable(data.mainAccount)}
        </div>
        <div className="mb-12">
          <h2 className="text-2xl font-bold ">Keshav Account</h2>
          {renderTable(data.subAccount1)}
        </div>

        <div className="mb-12">
          <h2 className="text-2xl font-bold ">QI Cap Account</h2>
          {renderTable(data.subAccount2)}
        </div>
              {/* <div className="mb-6">{renderTable(data.subAccount3, "Puneet Account (Other share class)")}</div> */}
            </div>
          );
};

export default BinanceBalance;